// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"14641802","167":"14641802"}[chunkId] + ".chunk.css";
};